import React from 'react';
import { AlertTriangle, Search, DollarSign, FileQuestion, XCircle } from 'lucide-react';

const ContextSection = () => {
  const painPoints = [
    {
      icon: AlertTriangle,
      title: "Embarques sem comprovação",
      description: "Sem registro confiável, qualquer discussão vira prejuízo para o operador"
    },
    {
      icon: Search,
      title: "Passageiros não autorizados",
      description: "Risco jurídico, quebra de compliance e desgaste com a empresa contratante"
    },
    {
      icon: DollarSign,
      title: "Falta de evidência para SLA",
      description: "Dificuldade em comprovar pontualidade e execução do serviço"
    },
    {
      icon: FileQuestion,
      title: "Custos invisíveis na operação",
      description: "Rotas mal utilizadas, falhas de controle e baixa previsibilidade"
    },
    {
      icon: XCircle,
      title: "Desgaste Operacional",
      description: "Conflitos constantes com RH, facilities e gestores do contrato"
    }
  ];

  return (
    <section id="context" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Dores do Fretamento Corporativo
          </h2>
          <p className="text-xl text-gray-600">
            Desafios que impactam operadores e colocam contratos em risco
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {painPoints.map((point, index) => {
            const Icon = point.icon;
            return (
              <div 
                key={index}
                className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-red-200 hover:-translate-y-1"
              >
                <div className="absolute top-0 right-0 w-32 h-32 bg-red-50 rounded-bl-full opacity-50"></div>
                
                <div className="relative">
                  <div className="w-14 h-14 rounded-xl bg-red-100 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-7 h-7 text-red-600" />
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {point.title}
                  </h3>
                  
                  <p className="text-gray-600 leading-relaxed">
                    {point.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-16 max-w-4xl mx-auto bg-gradient-to-r from-red-50 to-orange-50 rounded-2xl p-8 border border-red-100">
          <div className="flex items-start gap-6">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
                <AlertTriangle className="w-8 h-8 text-red-600" />
              </div>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                O Custo da Falta de Governança
              </h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                Sem controle estruturado, o operador assume riscos desnecessários: perda de contratos; multas contratuais; dificuldade de renovação; imagem comprometida no mercado corporativo. 
                <span className="font-semibold text-red-700">Governança deixou de ser diferencial. Hoje é exigência.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContextSection;
